import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CreateVoucher, Voucher } from "../types/Voucher";
import { API, fetcher } from "@/shared/core-configs";
import { GET_VOUCHERS_KEY } from "./useGetVouchers";
import { AxiosError } from "axios";

export const updateVoucher = async ({
  id,
  data,
}: {
  id: string;
  data: Partial<CreateVoucher>;
}): Promise<Voucher> => {
  const res = await fetcher.put(`${API.GESLUB_SERVICE}/voucher/${id}`, data);
  return res.data;
};

export const useUpdateVoucher = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation<
    Voucher,
    AxiosError<{ message: string }>,
    {
      id: string;
      data: Partial<CreateVoucher>;
    }
  >({
    mutationFn: updateVoucher,
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [GET_VOUCHERS_KEY],
      });
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return {
    updateVoucher: mutateAsync,
    isPending,
  };
};
